module.exports = __webpack_public_path__ + "img/C03TechSuperWarship_ua.30aaf268.webp";